import { AlertBanner } from "@jti/core-components/components/AlertBanner";
import { useTranslations } from "@jti/ui/providers/useTranslations";

import type { TradeInDisabledData } from "@product-details/containers/StandardProductDetailsContainer/components/types";

import { TradeInAlertBanner } from "./components";

type TradeInBlockProps = {
  tradeInDisabledData: Exclude<TradeInDisabledData, { status: "not-disabled" } | { status: "loading" }>;
  nonTradeInSku: string;
  className: string;
  onRegisterDeviceClick?: () => void;
};

export const TradeInDisabledBlock = ({
  tradeInDisabledData,
  nonTradeInSku,
  className,
  onRegisterDeviceClick,
}: TradeInBlockProps) => {
  const { __ } = useTranslations();

  return (
    <div className={className} data-testid="trade-in-alert-block">
      {tradeInDisabledData.status === "error" ? (
        <AlertBanner
          tone="error"
          title={__("productdetails.tradein.error.api.title")}
          description={__("productdetails.tradein.error.api.text")}
        />
      ) : (
        <TradeInAlertBanner
          cause={tradeInDisabledData.cause}
          nonTradeInSku={nonTradeInSku}
          onRegisterDeviceClick={onRegisterDeviceClick}
        />
      )}
    </div>
  );
};
